import _ from 'lodash';
import { getAxiosClient } from '~src/api';
import { getState } from '~src/state';

export const fetchEditorImages = async (forceFetch = false) => {
  const httpClient = await getAxiosClient();

  const currentTag = getState('sidebarCurrentImagesTag', 'NO_TAG');

  const hasCache = _.has(
    window.editorConfig,
    `sidebarImages[${currentTag}].items`
  );

  if (!forceFetch && hasCache) {
    return {
      images: {
        allowNew: false,
        items: window.editorConfig.sidebarImages[currentTag].items,
      },
    };
  }

  const params = {
    sort_descending: 'createdAt',
  };
  const paramsDefault = {
    sort_ascending: 'order',
  };
  params['limit'] = 500;
  paramsDefault['limit'] = 500;

  if (currentTag && currentTag !== 'NO_TAG') {
    paramsDefault[
      'innerQueryContains_tags'
    ] = `editor_images_tags,name,${currentTag}`;
    params['innerQueryContains_tags'] = `editor_images_tags,name,${currentTag}`;
  }

  const promiseDefault = httpClient.get(
    `${process.env.PARSE_API_URL}/editor_images_default`,
    { params: paramsDefault }
  );

  const promiseCustom = httpClient.get(
    `${process.env.PARSE_API_URL}/editor_images`,
    { params }
  );

  try {
    const responses = await Promise.all([promiseDefault, promiseCustom]);
    let items = [];

    responses.forEach((response) => {
      items = [...items, ...response.data.data];
    });

    const sortedItems = _.orderBy(items, 'isGlobal', 'desc');

    return {
      images: {
        allowNew: false,
        items: sortedItems,
      },
    };
  } catch (error) {
    console.error(error);
  }
};
